import { createVuetify } from "vuetify";
import { es, en } from "vuetify/locale";

/**
 * Vuetify 4.
 *
 * Notas de la migración desde Vuetify 2:
 *
 *  - El locale se importa de "vuetify/locale". La ruta anterior,
 *    "vuetify/src/locale/es", ya no resuelve.
 *
 *  - Los umbrales de breakpoint invierten su semántica. En V2 `thresholds` era
 *    el límite SUPERIOR de cada breakpoint; desde V3 es el límite INFERIOR.
 *    Copiar `{ sm: 1200, md: 1400 }` tal cual cambiaría qué resuelve
 *    `d-none d-md-block`, y esa clase es la que decide entre el toolbar de
 *    escritorio y el de móvil en las nueve vistas Index.
 *
 *    Intención original (V2, límites superiores):
 *        xs  <  600 | sm  < 1200 | md  < 1400 | lg y arriba
 *    Equivalente (V4, límites inferiores):
 *        sm >=  600 | md >= 1200 | lg >= 1400
 */
export const vuetify = createVuetify({
  theme: {
    defaultTheme: "light",
    themes: {
      light: {
        colors: {
          primary: "#182D4F",
          secondary: "#424242",
          accent: "#862930",
          error: "#FF5252",
          info: "#2196F3",
          success: "#4CAF50",
          warning: "#FFC107",
        },
      },
    },
  },
  locale: {
    locale: "es",
    fallback: "en",
    messages: { es, en },
  },
  display: {
    thresholds: {
      xs: 0,
      sm: 600,
      md: 1200,
      lg: 1400,
      xl: 1920,
      xxl: 2560,
    },
  },
  defaults: {
    // Paridad visual con la app anterior: en Vuetify 2 estos componentes se
    // usaban siempre con `outlined` y `dense`, props que en V3+ pasaron a ser
    // `variant` y `density`. Poniéndolo por defecto, los templates portados no
    // tienen que repetirlo campo por campo.
    //
    // `maxErrors` es una corrección, no una preferencia: Vuetify muestra UN solo
    // error por campo por omisión, y la API puede devolver varios sobre el mismo.
    // Un email de más de 254 caracteres, por ejemplo, viola @Email y @Size a la
    // vez y el usuario sólo veía la mitad del problema.
    VTextField: { variant: "outlined", density: "comfortable", maxErrors: 5 },
    VSelect: { variant: "outlined", density: "comfortable", maxErrors: 5 },
    VAutocomplete: { variant: "outlined", density: "comfortable", maxErrors: 5 },
    VTextarea: { variant: "outlined", density: "comfortable", maxErrors: 5 },
    VFileInput: { variant: "outlined", density: "comfortable", maxErrors: 5 },
  },
});
